module.exports = __webpack_public_path__ + "static/img/5257_phase_function_Paper_Points.c4e0f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5257_phase_function_Paper_Points.png
// module id = TtQW
// module chunks = 0